import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { POST_IDEAS } from "../data/postIdeas";

export default function PostIdeasIndexPage() {
  return (
    <>
      <Helmet>
        <title>LinkedIn Post Ideas for Engineers, by Role (2026) — PostWriter</title>
        <meta
          name="description"
          content="Curated LinkedIn post ideas for engineers by role: DevOps, SRE, ML engineers, cloud engineers, data scientists, engineering managers, and technical PMs."
        />
        <meta property="og:url" content="https://postwriter.tech/post-ideas" />
        <meta property="og:title" content="LinkedIn Post Ideas for Engineers, by Role" />
        <meta property="og:image" content="https://postwriter.tech/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://postwriter.tech/post-ideas" />
      </Helmet>
      <main className="min-h-screen bg-background font-body">
        <header className="border-b border-border">
          <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo.png" alt="PostWriter" className="w-7 h-7" />
              <span className="text-lg font-bold font-headline text-foreground">PostWriter</span>
            </Link>
            <Link
              to="/"
              className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              <ArrowLeft className="w-4 h-4" /> Back to home
            </Link>
          </div>
        </header>

        <div className="max-w-3xl mx-auto px-6 py-16">
          <h1 className="font-headline text-4xl md:text-5xl font-extrabold tracking-tighter leading-tight text-foreground mb-6">
            LinkedIn post ideas,{" "}
            <span className="text-primary italic">by engineering role.</span>
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed mb-12 max-w-2xl">
            Proven hooks and angles for technical professionals — written for people who ship
            real work, not marketers. Pick your role.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {POST_IDEAS.map((topic) => (
              <Link
                key={topic.slug}
                to={`/post-ideas/${topic.slug}`}
                className="group bg-muted/40 dark:bg-card rounded-2xl p-6 ring-1 ring-border/20 hover:ring-primary/40 transition-all"
              >
                <h2 className="font-headline text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                  {topic.persona}
                </h2>
                <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                  {topic.ideas.length} post ideas with hooks and angles
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-headline font-bold uppercase tracking-widest text-primary">
                  View ideas <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}
